import {
  all, takeLatest, put, call,
} from 'redux-saga/effects';
import {
  createErrorSnackBar,
  createSuccessSnackBar,
} from '../actions/snackbars';
import {
  surveyPostTourQuestionsRequestFailed,
  surveyPostTourQuestionsRequestSuccess,
  surveyQuestionsRequestFailed,
  surveyQuestionsRequestSuccess,
  updatePostTourSurveyQuestionsFailed,
  updatePostTourSurveyQuestionsSuccess,
  updateSurveyQuestions,
  updateSurveyQuestionsFailed,
  updateSurveyQuestionsSuccess,
} from '../actions/survey';
import {
  loadPostTourQuestions,
  loadQuestions,
  updatePostTourQuestions,
  updateQuestions,
} from '../../services/survey';
import {
  SURVEY_POST_TOUR_QUESTIONS,
  SURVEY_POST_TOUR_QUESTIONS_UPDATE,
  SURVEY_QUESTIONS,
  SURVEY_QUESTIONS_UPDATE,
} from '../types/survey';

function* loadSurveyQuestionsSaga() {
  try {
    const { data } = yield call(loadQuestions);
    yield put(surveyQuestionsRequestSuccess(data));
  } catch (err) {
    yield put(surveyQuestionsRequestFailed(err));
  }
}

function* updateSurveyQuestionsSaga(
  action: ReturnType<typeof updateSurveyQuestions>,
) {
  try {
    const { data } = yield call(updateQuestions, action.payload);
    yield put(createSuccessSnackBar('Questions updated'));
    yield put(updateSurveyQuestionsSuccess(data));
  } catch (err) {
    yield put(updateSurveyQuestionsFailed(err));
    yield put(
      createErrorSnackBar(
        err.response ? err.response.data.message : err.message,
      ),
    );
  }
}

function* loadSurveyPostTourQuestionsSaga() {
  try {
    const { data } = yield call(loadPostTourQuestions);
    yield put(surveyPostTourQuestionsRequestSuccess(data));
  } catch (err) {
    yield put(surveyPostTourQuestionsRequestFailed(err));
  }
}

function* updateSurveyPostTourSurveyQuestionsSaga(
  action: ReturnType<typeof updateSurveyQuestions>,
) {
  try {
    const { data } = yield call(updatePostTourQuestions, action.payload);
    yield put(createSuccessSnackBar('Post Tour Questions updated'));
    yield put(updatePostTourSurveyQuestionsSuccess(data));
  } catch (err) {
    yield put(updatePostTourSurveyQuestionsFailed(err));
    yield put(
      createErrorSnackBar(
        err.response ? err.response.data.message : err.message,
      ),
    );
  }
}

export default all([
  takeLatest<any>(SURVEY_QUESTIONS, loadSurveyQuestionsSaga),
  takeLatest<any>(SURVEY_QUESTIONS_UPDATE, updateSurveyQuestionsSaga),
  takeLatest<any>(SURVEY_POST_TOUR_QUESTIONS, loadSurveyPostTourQuestionsSaga),
  takeLatest<any>(SURVEY_POST_TOUR_QUESTIONS_UPDATE, updateSurveyPostTourSurveyQuestionsSaga),
]);
